// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(categoryName) {
  switch (categoryName) {
    case "CUSTOMER_EXPERIENCE" :
        return /* CustomerService */0;
    case "LOGIN_ACTIVITY" :
        return /* LoginActivity */1;
    case "ORDER_FULFILLMENT" :
        return /* OrderFulfillment */2;
    default:
      return ErrorUtils$Catalyst.raiseError("RewardCategory.re", "category name cannot be mapped to a valid category type", categoryName);
  }
}

function toString(categoryName) {
  switch (categoryName) {
    case /* CustomerService */0 :
        return "CUSTOMER_EXPERIENCE";
    case /* LoginActivity */1 :
        return "LOGIN_ACTIVITY";
    case /* OrderFulfillment */2 :
        return "ORDER_FULFILLMENT";
    
  }
}

function toDisplayString(categoryName, content) {
  switch (categoryName) {
    case /* CustomerService */0 :
        return content.category.customerService;
    case /* LoginActivity */1 :
        return content.category.loginHours;
    case /* OrderFulfillment */2 :
        return content.category.orderFulfillment;
    
  }
}

export {
  fromString ,
  toString ,
  toDisplayString ,
  
}
/* No side effect */
